import React from 'react';
import Tr from './Tr';
import '../../css/table.css';
import language from '../../variables/language';
import TrMessages from './TrMessages';

 const Table = ({ headers, data ,status, table, thead, tbody, htr, btr, th, td, onRefreshHundler , stateHundler,label, props}) => {
   return (
    <div style={{position:'relative',minHeight: status ==='loading' ? '84vh':'unset'}}
     className={props && props.tableWrapper? props.tableWrapper:''}>
     <table border="1" className={table} >
       <thead  className={thead} >
         <tr  className={htr}>
           {Object.keys(headers).map(header => (
             <th  className={th} key={header}>
              <div> {language[language.lang][header]} </div>
              </th>
           ))}
         </tr>
       </thead>
       <tbody className={tbody} >

       {status === 'loading' ?

                (<tr style={{textAlign:'center', width:'100%',minWidth:'100%', position:'absolute',
                top:'20%', left:0, right:0,display:'flex'}}> 
                  <td colSpan="..." className="info-mssg loading-msg" 
                  style={{textAlign:'center',padding:20,fontSize:16, marginInline:'auto'}}>
                    {language[language.lang]['Loading ...']}
                    </td>
                </tr>) 
                : ('')
      }

      {status === 'done' && data.length >= 1? 

                (data.map((item, index) => (
                      props && props.messages ? 

                      <TrMessages props={props} btr={btr} td={td} key={index} label={label}
                       onRefreshHundler={onRefreshHundler} stateHundler={stateHundler} headers={headers} item={item} />
                      :
                      <Tr props={props} btr={btr} td={td} key={index} label={label}
                       onRefreshHundler={onRefreshHundler} stateHundler={stateHundler} headers={headers} item={item} />
                      
                    ))) 
                    : ('')
      }

      {status === 'done' && data.length < 1 ? 
              (<tr>
                      <td colSpan="..." className="info-mssg" style={{textAlign:'center',padding:20}}>
                      {language[language.lang]['Empty list']}
                      </td>
                    </tr>)
                    :
                    ('')
       }
                
     

       </tbody>
     </table>
     </div>
   );
 };
 export default Table;
 